import { ApiTags, rootApi } from "../../../../services/rootApi";
import { IShuttleBooking, IShuttleRoute } from "./shuttleBooking";


const TAG = ApiTags.ShuttleBooking;
const getTags = (entities: IShuttleRoute[]) => [...entities.map((p) => ({ type: TAG, id: p.id })), TAG]

const shuttleBookingApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getRoutes: builder.query<IShuttleRoute[], void>({
      query: () => `/ShuttleBooking`,
      providesTags: (result) => result ? getTags(result) : [TAG]
    }),

    updateShuttle: builder.mutation<IShuttleBooking[], { routeId: string, capacity: number, date: string }>({
      query: ({ routeId, capacity, date }) => {
        return `/ShuttleBooking/routeId(${routeId})/(${capacity})/(${date})`;
      },
    }),
  })
})

export const {
  useGetRoutesQuery,
  useUpdateShuttleMutation,
} = shuttleBookingApi;